import type { DynamicClient } from '@dynamic-labs-sdk/client';
import { getChainFromVerifiedCredentialChain } from '@dynamic-labs-sdk/client/core';
import { WalletProviderEnum } from '@dynamic-labs/sdk-api-core';

import { ZERODEV_METADATA } from '../../constants';

export const getAllUserZerodevAddresses = (client: DynamicClient): string[] => {
  const zerodevWalletCredentials =
    client.user?.verifiedCredentials.filter(
      (credential) =>
        credential.walletProvider === WalletProviderEnum.SmartContractWallet &&
        credential.walletName
          ?.toLowerCase()
          .startsWith(ZERODEV_METADATA.normalizedWalletName) &&
        credential.address &&
        credential.chain &&
        getChainFromVerifiedCredentialChain(credential.chain) === 'EVM'
    ) ?? [];

  const zerodevAddresses: string[] = zerodevWalletCredentials.map(
    // casting because we're already filtering out credentials without an address
    (credential) => credential.address as string
  );

  return zerodevAddresses;
};
